import { useEffect, useState } from "react"

import { Outlet } from "react-router-dom"

// material-ui
import { styled } from "@mui/material/styles"
import LinearProgress, { LinearProgressProps } from "@mui/material/LinearProgress"
import useConfig from "../../../hooks/useConfig"
import Header from "./Header"
import MediaQuery from "react-responsive"
import MobilePage from "../MobilePage"
import TunefundLogo from "components/logo/TunefundLogo"
import { KSpan } from "kahuna-base-react-components"
import { calculateSize, checkMobile } from "utils"
import KahunaLogoWhite from "../../../assets/images/slush/kahuna-white-logo.svg"
import KahunaText from "../../../assets/images/slush/kahuna-text.svg"

// ==============================|| LOADER - WRAPPER ||============================== //

const LoaderWrapper = styled("div")(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: 2001,
  width: "100%",
  "& > * + *": {
    marginTop: theme.spacing(2)
  }
}))

export interface LoaderProps extends LinearProgressProps {}

const Loader = () => (
  <LoaderWrapper>
    <LinearProgress color="primary" />
  </LoaderWrapper>
)

// ==============================|| MINIMAL LAYOUT ||============================== //

const OffersCommonLayout = ({ layout = "blank", backgroundColor }: { layout?: string; backgroundColor: string }) => {
  const { onChangePresetColor } = useConfig()
  const [isLinkTree, setIsLinkTree] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    onChangePresetColor("theme1")
    const url = window.location.origin
    if (url.includes("slush.kahuna.io")) {
      //if (url.includes("localhost")) {
      setIsLinkTree(true)
    }

    const mobile = checkMobile()
    setIsMobile(mobile)
  }, [])

  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [screenHeight, setScreenHeight] = useState(window.innerHeight)

  useEffect(() => {
  const handleResize = () => {
    setScreenWidth(window.innerWidth)
    setScreenHeight(window.innerHeight)
  }

  window.addEventListener("resize", handleResize)

  // cleanup
  return () => window.removeEventListener("resize", handleResize)
  }, [])

  const renderFullPage = () => {
    return (
      <div style={{ height: "100vh", backgroundColor }}>
        <div style={{ height: "10%" }}>
          <Header layout={layout} backgroundColor={backgroundColor} />
        </div>
        <div style={{ height: "90%" }}>
          <Outlet />
        </div>
      </div>
    )
  }

  const renderOther = () => {
    const textColor = "#FFF"
    const bgColor = "#000"
    const logoWidth = calculateSize(screenWidth, screenHeight, isMobile, 160)
    if (isLinkTree) {
      return (
        <div
          className="flex justify-center items-center"
          style={{
            height: "100vh",
            backgroundColor: "#000",
            padding: calculateSize(screenWidth, screenHeight, isMobile, 10)
          }}
        >
          <div
            style={{
              backgroundColor: bgColor,
              borderRadius: calculateSize(screenWidth, screenHeight, isMobile, 10),
              height: "100%",
              display: "flex",
              flexDirection: "column",
              overflowY: "auto"
            }}
          >
            <div
              style={{
                flex: screenWidth < 400 && screenHeight < 750 ? "0 1 25%" : "0 1 30%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "center"
              }}
            >
              <div className="flex justify-center">
                <div
                  className="inline-flex"
                  style={{
                    border: `2px solid ${textColor}`,
                    borderRadius: 99,
                    padding: calculateSize(screenWidth, screenHeight, isMobile, 8),
                    marginTop: calculateSize(screenWidth, screenHeight, isMobile, 16)
                  }}
                >
                  <KSpan
                    text="SLUSH'D ISTANBUL"
                    fontWeight={500}
                    color={textColor}
                    fontSize={calculateSize(screenWidth, screenHeight, isMobile, 12)}
                    lineHeight={`${calculateSize(screenWidth, screenHeight, isMobile, 12) + 8}px`}
                  />
                </div>
              </div>
              {/*<div className="flex justify-center">
              <TunefundLogo width={calculateSize(screenWidth, screenHeight, isMobile, 160)} textVisible={true} paddingHorizontal={calculateSize(screenWidth, screenHeight, isMobile, 10)} />
            </div>*/}
              <div
                className="flex flex-row items-center justify-center"
                style={{
                  marginTop: calculateSize(screenWidth, screenHeight, isMobile, 48),
                  marginBottom: calculateSize(screenWidth, screenHeight, isMobile, 24),
                  gap: calculateSize(screenWidth, screenHeight, isMobile, 24),
                  paddingLeft: calculateSize(screenWidth, screenHeight, isMobile, 24),
                  paddingRight: calculateSize(screenWidth, screenHeight, isMobile, 24)
                }}
              >
                <img
                  src={KahunaLogoWhite}
                  alt="logo-white"
                  className="shrink-1"
                  width={logoWidth / 1.65 / 2.66}
                  height={logoWidth / 1.65 / 2}
                />
                <img src={KahunaText} alt="logo-text" className="shrink-1" width={logoWidth} height={logoWidth / 3} />
              </div>
            </div>
            <div
              style={{
                flex: screenWidth < 400 && screenHeight < 750 ? "1 1 75%" : "1 1 70%",
                flexDirection: "column",
                justifyContent: "flex-start"
              }}
            >
              <Outlet />
            </div>
          </div>
        </div>
      )
    }
    return (
      <div
        style={{ position: "relative", height: "100vh", backgroundColor: "#F0F0F0", padding: 10, overflowX: "hidden" }}
      >
        <div style={{ backgroundColor, height: "100%", borderRadius: 10, boxShadow: "0px 2px 2px 0px lightgray" }}>
          <div style={{ height: "10%" }}>
            <Header layout={layout} backgroundColor={backgroundColor} />
          </div>
          <div style={{ height: "90%" }}>
            <Outlet />
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            height: "10px",
            width: "100%",
            backgroundColor: "#F0F0F0",
            zIndex: 10,
            boxShadow: "0px 2px 2px 0px lightgray"
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            left: -1,
            width: "11px",
            height: "100%",
            backgroundColor: "#F0F0F0",
            zIndex: 10
            //boxShadow: "0px 2px 2px 0px lightgray"
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            right: -1,
            width: "11px",
            height: "100%",
            backgroundColor: "#F0F0F0",
            zIndex: 10
            //boxShadow: "0px 2px 2px 0px lightgray"
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            width: "20px",
            height: "20px",
            backgroundColor: "#F0F0F0",
            zIndex: 10,
            overflow: "hidden"
            //boxShadow: "0px 2px 2px 0px lightgray"
          }}
        >
          <div
            style={{
              position: "absolute",
              top: -10,
              left: -10,
              width: "20px",
              height: "20px",
              zIndex: 10,
              borderRadius: "10px",
              backgroundColor: "#FFF"
            }}
          />
        </div>
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "20px",
            height: "20px",
            backgroundColor: "#F0F0F0",
            zIndex: 10,
            overflow: "hidden"
            //boxShadow: "0px 2px 2px 0px lightgray"
          }}
        >
          <div
            style={{
              position: "absolute",
              top: -10,
              right: -10,
              width: "20px",
              height: "20px",
              zIndex: 10,
              borderRadius: "10px",
              backgroundColor: "#FFF"
            }}
          />
        </div>
        <div
          style={{
            position: "absolute",
            top: 0,
            right: -1,
            width: "11px",
            height: "100%",
            backgroundColor: "#F0F0F0",
            zIndex: 10
            //boxShadow: "0px 2px 2px 0px lightgray"
          }}
        />
      </div>
    )
  }

  // choices are: "full", "partial", "blank", "login", "landing-text"
  return layout === "full" ? renderFullPage() : renderOther()
}

export default OffersCommonLayout
